import { ModuleName } from "../AxSystem/AxInit";
import { Map } from "../Types/Map";

@ModuleName("I18nHelper")
export class I18nHelper {
    static TransList: Map<string> = new Map<string>();
    private static Loaded: boolean = false;

    constructor() {
        if (!I18nHelper.Loaded) {
            if (typeof Translation == 'undefined' || Translation == null) {
                return;
            }

            for (let trans of Translation) {
                I18nHelper.TransList.add(trans[0].charAt(0).toUpperCase() + trans[0].slice(1), trans[1]);
            }
        }
    }

    GetTranslation(key: Translations, ...args: any[]): string {
        let translation = I18nHelper.TransList.get(Translations[key]);
        const flatArgs = args.flat();

        return (translation || '').replace(/\{(\d+)\}/g, (_, index) => flatArgs[Number(index)] ?? '');
    }

    GetTranslationDict() {
        return Translations
    }
}

//Always Uppercase
export enum Translations {
    Ticket,
    Tickets,
    Reserve,
    Summary,
    Checkout,
    Timings,
    QuantityDate,
    Error,
    TicketVerification,
    ReservationManagement,
    DateTimeReservation,
    Confirmation,
    Next,
    CountAvailable,
    AreYouSure,
    OneWayReservation,
    ConfirmReservation,
    DeleteReservationPopup,
    DeleteConfirmationPopup,
    NotValidSerialNumber,
    ValueMissing,
    CartAdd,
    OnlyNumbers,
    NotValidWtp,
    DrpZneDefaultMessage,
    Various,
    People,
    DrpZneFallbackMessage,
    Location,
    DrpZneFallbackText,
    DrpZneFileTooBig,
    DrpZneInvalidFileType,
    SlotsN,
    WTPNumberNotFound,
    LevelsAll,
    DrpZneResponseError,
    DrpZneCancelUpload,
    DrpZneCancelUploadConfirmation,
    DrpZneRemoveFile,
    DrpZneMaxFilesExceeded,
    Success,
    FeldErforderlich,
    AddressPleaseAdd,
    BookNow,
    PasswordNotValid,
    PasswordUnequal,
    SelectTicket,
    AmountAndDesign,
    Personalize,
    ValidationMail,
    From,
    To,
    Message,
    PleaseSelectGiftCardTemplate,
    Cancel,
    SelectCard,
    SlotsAvailable,
    DeviceNotSupported,
    ServerErrorText1,
    ServerErrorText2,
    Oops,
    Ok,
    OutOfX,
    VoucherCurrentlyNotRedeemable,
    VoucherNotPartlyRedeemable,
    CartCart,
    ProductSelectionRequired,
    WtpPleaseInsert,
    ShowXResults,
    LegitimationCheckError,
    SelectDate,
    Continue,
    SelectAtLeastOneTicket,
    State,
    LoginCredentialsWrong,
    LoginSuccess,
    AddCoverPoster,
    AddCoverForVideo,
    YesPlease,
    NoThanks,
    Whoops,
    MaxQuantity,
    MinQuantity,
    MaximumFileSize,
    AcceptableFilesExtention,
    ConfirmationEmailSent,
    Free,
    SoldOut,
    MyTicketsInfoBarCode,
    MyTicketsInfoVoucher,
    MyTicketsInfoBLE,
    LinkCopiedToClipboard,
    WrongDay,
    WrongSelectedDay,
    AdminClose,
    Rentals,
    MandatoryRentalDataMissing,
    RentalNoPersonSelected,
    OneRISKProcessIsRequiredBeforeProceed,
    OneRISKNecessityMessage,
    Warning,
    WaiverSaveFail,
    WaiverIsCompleted,
    BodyLoggingEnabledAlert,
    RentalAdditionalOptions,
    RentalYouCanSkipThisPart,
    RentalNoProperties,
    ProceedToCheckout,
    QuantityTicket,
    SelectCategoryFirst,
    SelectDateFirst,
    SelectTicketFirst,
    TicketsX,
    SelectACategory,
    SelectAStartingDate,
    NumberOfTickets,
    WaiverModal,
    ResetSelection,
    ConfirmDelete,
    LinkedArticleWaiverCheckError,
    LinkedArticleWaiverDelete,
    LinkedArticleWaiverAlreadyExists,
    ShowDetails,
    Save,
    Edit,
    AdminCreateNewComplexPackage,
    CurrentlyUsed,
    SureToDelete,
    AdminFilter,
    StartShopping,
    ReservationExpired,
    SVCodeInvalidSyntax,
    SVCodeEmpty,
    AmountTotal,
    SVCodeAtWithThisFormat,
    MaintenanceActModeDesc,
    MaintenanceModeActOffSeasonDesc,
    MaintenanceModeDeActDesc,
    MaintenanceModeDeActOffSeasonDesc,
    Voucher,
    RequiredData,
    SelectAll,
    ShoppingCartCapitals,
    //#region i18Next
    I18NextRequired,
    I18NextMsgRadioCheck,
    I18NextMsgDropdown,
    I18NextMsgPhoneRequired,
    I18NextMsgPhoneOnlyNumbers,
    I18NextMsgPasswordInvalid,
    I18NextMsgPasswordUppercase,
    I18NextMsgPasswordLowercase,
    I18NextMsgPasswordDigit,
    I18NextMsgPasswordSpecChar,
    I18NextMsgEmail,
    I18NextMsgEmailGuestConfirm,
    I18NextNoResult,
    //#endregion i18Next
    PayPerUse,
    AdminMembership,
    WtpLoadScopeMandatory,
    WtpLoadScope,
    NextAdditionalPerson,
    WTPNumber,
    AdminDownload,
    MaxRentalHeight,
    AdminItemOrderNotChanged,
    AdminSortOrderUpdated,
    AdminUnexpectedErrorWhileSavingSortOrder,
    AdminCountCharactersHTML,
    AdminSelectProducts,
    AdminSelectLanguage,
    UndoableThings,
    SmarPromotionAriaLabel,
    Properties,

    // --- AdminMegaMenu Translations ---
    AdminMegaMenuNewLink,
    AdminMegaMenuSameTab,
    AdminMegaMenuNewTab,
    AdminMegaMenuDeleteCategoryTitle,
    AdminMegaMenuDeleteCategoryText,
    AdminMegaMenuYesDelete,
    AdminMegaMenuSubCategoryNamePrompt,
    AdminMegaMenuRequired,
    AdminMegaMenuDeleteSubCategoryTitle,
    AdminMegaMenuDeleteSubCategoryText,
    AdminMegaMenuSearchAssigned,
    AdminMegaMenuSearchAll,
    AdminMegaMenuCategorySettings,
    AdminMegaMenuSubCategoriesAndProducts,
    AdminMegaMenuSubCategories,
    AdminMegaMenuSubCategorySettings,
    AdminMegaMenuAssignedProducts,
    AdminMegaMenuSubCategoriesConfigured,
    AdminMegaMenuProductsCount,
    AdminMegaMenuCreateOrSelectSubCategory,
    AdminMegaMenuVisible,
    AdminMegaMenuUrl,
    AdminMegaMenuAvailable,
    AdminMegaMenuDefBadge,
    AdminMegaMenuCategoryMustBeDefaultFirst,
    AdminMegaMenuSubCategoryMustBeDefaultFirst,
    AdminStoreHeadline,
    AdminStoreCaption,
    AdminDefault,
    AdminDelete,
    AdminAdd,
    AdminName,
    AdminHeadline,
    AdminEnterACaption,
    Description,
    AdminAssets,
    GenericDefaultAssetOperation,
    GenericDefaultSetOperation,
    GenericDefaultRemoveOperation,
    MegaMenuSetDefaultInfo,
    QuickSelectorDefault,
    AdminSubCategory,
    AdminCategory,
    QuickSelectorSelectCategoryFirst,
    QuickSelectorSelectSubCategoryFirst,
    Categories,
    AdminActive,
    Inactive,
    ValidFrom,
    ValidTo,
    Create,
    Icon,
    BenefitRedeemError,
    BenefitLinkCopied,
    SomethingWrong,
    ReservationCancel,
    ReservationFor,
    Reschedule,
    Person,
    Confirm,
    HoursAndMinutes,
    Hour,
    Hours,
    Minutes,
    AdminHeroSettings,
    AdminMegaMenuHeroTitle,
    AdminMegaMenuHeroSubtitle,
    AdminMegaMenuHeroImage,
    BrandIdentityLogo,
    AdminMainColor,
    AdminAlternativeColor,
    RegisterMinimumAgeNotReached,
}
